import { render, staticRenderFns } from "./PrizeDraw.vue?vue&type=template&id=37763ff3&scoped=true&"
import script from "./PrizeDraw.vue?vue&type=script&lang=js&"
export * from "./PrizeDraw.vue?vue&type=script&lang=js&"
import style0 from "./PrizeDraw.vue?vue&type=style&index=0&id=37763ff3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37763ff3",
  null
  
)

export default component.exports